/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const DialogueIcon = /*#__PURE__*/ createSvgIcon(
  'DialogueIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M6 12c-.333 0-.617-.117-.85-.35a1.157 1.157 0 01-.35-.85V10h7.6V4.8h.8c.333 0 .617.117.85.35.233.233.35.517.35.85v6.95a.562.562 0 01-.367.56c-.244.104-.461.062-.652-.129L12.001 12H6zM4 8.8l-1.38 1.381a.546.546 0 01-.652.128.565.565 0 01-.367-.563V2.8c0-.333.117-.617.35-.85.233-.233.517-.35.85-.35H10c.333 0 .617.117.85.35.233.233.35.517.35.85v4.8c0 .333-.117.617-.35.85-.233.233-.517.35-.85.35H4zM10 7.6V2.8H2.8v4.8H10z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default DialogueIcon;
